module.exports = __webpack_public_path__ + "img/github.a0b83118.svg";